module.exports = __webpack_public_path__ + "img/icon_iterate_color.0904c21b.png";